import { useMemo } from "react";
import { usePropertyData } from "../../../../components/property-admin-data-provider";
import { useChainData } from "../../../../components/chain-data-provider";
import { usePropertyInventoryData } from "../../../../components/inventory-provider";

export function useInventory() {
  const chainData = useChainData();
  const propertyData = usePropertyData();
  const propertyInventoryData = usePropertyInventoryData();

  const isChain = useMemo(() => chainData?.isChain, [chainData]);

  const allowedInventoryLines = useMemo(() => {
    if (propertyData?.inventories?.length) {
      return propertyData.inventories.map(({ ticker, accommodation, configuration, mealPlan, condition }) => {
        return {
          ticker,
          name: `${accommodation.name} / ${configuration.name}, ${mealPlan.name}, ${condition.name}`,
          filters: { accommodation, condition, configuration, mealPlan },
        };
      });
    }
    return [];
  }, [propertyData]);

  const allowedChainInventoryLines = useMemo(() => {
    if (isChain && propertyInventoryData && propertyInventoryData.length) {
      return propertyInventoryData.map(({ propertyTicker, inventoryTickers }) => {
        return ({
          [propertyTicker]: inventoryTickers?.map(({ ticker, accommodation, configuration, mealPlan, condition }) => {
            return {
              ticker,
              name: `${accommodation.name} / ${configuration.name}, ${mealPlan.name}, ${condition.name}`,
              filters: { accommodation, condition, configuration, mealPlan },
            };
          })
        })
      });
    }
    return [];
  }, [isChain, propertyInventoryData]);

  const allowedChainInventoryLinesOptions = useMemo(() => {
    return allowedChainInventoryLines.map((it) => Object.values(it)[0]);
  }, [allowedChainInventoryLines]);

  const allowedChainInventoryLinesTickers = useMemo(() => {
    return allowedChainInventoryLines.map((it) => Object.keys(it)[0]);
  }, [allowedChainInventoryLines]);

  const loadChainInventoryLinesAllowed = useMemo(() => {
    return isChain
      && allowedChainInventoryLines.length > 0
      && allowedChainInventoryLinesOptions.length > 0
      && allowedChainInventoryLinesTickers.length > 0;
  }, [
    allowedChainInventoryLines.length,
    allowedChainInventoryLinesOptions.length,
    allowedChainInventoryLinesTickers.length,
    isChain,
  ]);

  const loadInventoryLinesAllowed = useMemo(() => {
    return allowedInventoryLines.length > 0
  }, [allowedInventoryLines.length]);

  return {
    allowedInventoryLines,
    allowedChainInventoryLines,
    allowedChainInventoryLinesOptions,
    allowedChainInventoryLinesTickers,
    loadChainInventoryLinesAllowed,
    loadInventoryLinesAllowed,
  };
}